"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wifi = void 0;
var react_1 = __importDefault(require("react"));
var Wifi = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" }, props),
    react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.4 8.175c-5.644-4.233-13.155-4.233-18.8 0a1 1 0 1 1-1.2-1.6c6.356-4.767 14.844-4.767 21.2 0a1 1 0 0 1-1.2 1.6ZM18.4 13.425c-3.644-2.733-9.155-2.733-12.8 0a1 1 0 0 1-1.2-1.6c4.356-3.267 10.845-3.267 15.2 0a1 1 0 0 1-1.2 1.6ZM14.972 17.524c-1.927-1.199-4.017-1.198-5.944 0a1 1 0 0 1-1.056-1.698c2.574-1.601 5.483-1.601 8.057 0a1 1 0 0 1-1.057 1.698ZM12.674 18.932a1 1 0 0 1 .074 1.413l-.01.01a1 1 0 1 1-1.486-1.338l.01-.01a1 1 0 0 1 1.412-.075Z", clipRule: "evenodd" }))); };
exports.Wifi = Wifi;
